import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';

@Component({
  selector: 'rr-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss'],
})
export class DateRangeFilterComponent implements OnInit, AfterViewInit {
  private _isInitiated: boolean;

  @Input() model: RRIFilter<number[], number[]>;
  @Output() changedFilter: EventEmitter<RRIFilterOutput<number[]>> =
    new EventEmitter();
  @Output() cleanFilterClicked: EventEmitter<RRIFilter<number[], number[]>> =
    new EventEmitter();

  public dateRangeFieldModel: RRIInput<Date[]>;

  constructor() {
    this._isInitiated = false;
    this.dateRangeFieldModel = {
      fieldName: 'filter-date-range',
      label: '',
    };
  }

  ngOnInit(): void {
    this.dateRangeFieldModel.label = this.model?.settings?.title ?? '';
    this.dateRangeFieldModel.placeholder = this.model?.settings?.title ?? '';
    this.dateRangeFieldModel.showDateRanges = true;
    this.dateRangeFieldModel.showFieldHasValue =
      this.model?.settings?.showFieldHasValue;
  }

  ngAfterViewInit(): void {
    this._isInitiated = true;
  }

  public onDateRangeFieldChange(event: Date[]): void {
    if (!event || event.length !== 2) {
      return;
    }

    const startDate = event[0].setHours(0, 0, 0, 0);
    const endDate = event[1].setHours(23, 59, 59, 0);

    if (this._isInitiated) {
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DATE_RANGE,
        filterBy: {
          ...this.model.filterBy,
          value: [startDate / 1000, endDate / 1000],
        },
      });
    }
  }

  public onClearDateRangeField(event: any): void {
    this.cleanFilterClicked.emit(this.model);

    if (!this.model.filterBy.value || this.model.filterBy.value.length !== 2) {
      return;
    }

    if (this._isInitiated) {
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DATE_RANGE,
        filterBy: {
          ...this.model.filterBy,
          value: [],
        },
      });
    }
  }
}
